import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { formatDate } from "./dateUtils";
import { message } from "antd";

/**
 * Calcula el nombre de la alarma con la misma lógica/prioridad que la tabla de Alarms.
 * Prioridad: Temperatura > Humedad > Impacto > Apertura
 */
const getAlarmName = (record) => {
  if (record.alarmTemp) return "Temperatura";
  if (record.alarmHum) return "Humedad";
  if (record.alarmImpact) return "Impacto";
  if (record.alarmOpen) return "Apertura";
  return "N/D";
};

/**
 * Definición de campos para la exportación de alarmas.
 * Alineados con las columnas de la tabla AlarmsTable.
 */
const fieldDefinitions = [
  { key: "shipmentCode", label: "CÓDIGO DE BULTO" },
  { key: "imei", label: "IMEI" },
  { key: "numRefClient", label: "REF. CLIENTE / PEDIDO" },
  { key: "senderName", label: "REMITENTE" },
  { key: "eventName", label: "ÚLTIMO EVENTO" },
  {
    key: "eventDate",
    label: "FECHA Y HORA EVENTO",
    transform: (item) => formatDate(item.eventDate),
  },
  { key: "eventLocation", label: "UBICACIÓN DEL EVENTO" },
  { key: "destinationName", label: "DESTINATARIO" },
  {
    key: "alarmName",
    label: "ALARMA",
    transform: (item) => getAlarmName(item),
  },
  {
    key: "alarmStartDate",
    label: "FECHA Y HORA ALARMA",
    transform: (item) => formatDate(item.alarmStartDate),
  },
];

/**
 * Formatea un registro de alarma para exportación.
 */
const formatItem = (item) =>
  fieldDefinitions.reduce((acc, { key, label, transform }) => {
    acc[label] = transform ? transform(item) : item[key] || "N/D";
    return acc;
  }, {});

/**
 * Genera un timestamp para el nombre del archivo.
 */
const getTimestamp = () => {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat("es-ES", {
    timeZone: "Europe/Madrid",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const parts = formatter.formatToParts(now);
  const map = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${map.year}${map.month}${map.day}_${map.hour}${map.minute}${map.second}`;
};

/**
 * Exporta datos de alarmas a CSV o Excel.
 * @param {Array} data - Array de registros de alarmas
 * @param {string} fileType - Tipo de archivo: "csv" o "excel"
 */
export function exportAlarmsData(data, fileType) {
  try {
    const formattedData = (data || []).map(formatItem);
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Alarmas");

    const timestamp = getTimestamp();
    const ext = fileType === "excel" ? "xlsx" : "csv";
    const fileName = `DatosAlarmas_${timestamp}.${ext}`;

    if (fileType === "csv") {
      const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ";" });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, fileName);
    } else if (fileType === "excel") {
      XLSX.writeFile(workbook, fileName, { bookType: "xlsx" });
    } else {
      throw new Error("Tipo de archivo no soportado");
    }

    message.success(`Archivo descargado correctamente: ${fileName}`);
  } catch (error) {
    console.error("Error exportando datos de alarmas:", error);
    message.error(
      `Error al exportar los datos en formato ${String(fileType).toUpperCase()}`,
    );
  }
}
